import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HttpService } from 'src/app/http.service';
import { SnackbarService } from 'src/app/snackbar.service';
import { Messages } from '../../constants/messages';
import { ValidationService } from 'src/app/validation.service';
import { StorageService } from 'src/app/storage.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

export interface AddVehicleType {
  registrationNumber: string;
  type: string;
  registrationYear?: number;
  chassisNumber?: string;
  engineNumber?: number;
  mileage?: number;
  transporter?: string;
  mileageUnit?: string;
  tankCapacity?: number;
  tankCapacityUnit?: string;
  vehiclePic?: File;
  gps_id?: string;
  gps_provider?: string;
  actual_capacity?: number;
}

@Component({
  selector: 'app-add-vehicle',
  templateUrl: './add-vehicle.component.html',
  styleUrls: ['./add-vehicle.component.scss']
})
export class AddVehicleComponent implements OnInit {

  file: File;
  newVehicleData: AddVehicleType = {
    registrationNumber: '',
    type: '',
    mileageUnit: 'KPL',
    tankCapacityUnit: 'L',
    actual_capacity: 0,
  };

  type;
  showLoader = false;
  formData = new FormData();
  vehicleKey: any = {};
  vehicleKey1: any = {};
  ksa_gps_providers = [
    // {
    //   name: 'Mix',
    //   value: 'MIX'
    // },
    // {
    //   name: 'Max Media',
    //   value: 'MAX_MEDIA'
    // }
  ];
  in_gps_providers = [];
  gps_providers: any = [];
  assets;
  assetsArray;
  selectedGPSProvider;
  selectedAsset;
  showGPSProvider = false;
  messages = new Messages();
  d = new Date();
  minYear: any;
  vehicletypes: any = [];
  vehicle_pattern;

  showVerifyLinks = false;
  spinner = false;

  constructor(private dialog: MatDialogRef<AddVehicleComponent>,
    private http: HttpService, private snackbar: SnackbarService,
    private validData: ValidationService, private storage: StorageService, private translation: TranslateService
    , @Inject(MAT_DIALOG_DATA) private parentData: any
  ) { }

  ngOnInit() {
    this.showVerifyLinks = environment.country === 'IN';
    this.vehicle_pattern = environment.vehicle_pattern;

    
    this.getVehicleTypes();
    this.getGPSProviders();
    this.minYear = this.d.getFullYear() - 15;

    if (this.parentData) {      
      if (this.parentData.vehicle) {       
        this.vehicleKey = this.parentData.vehicle;      
      }
    }
   

  }

  fileChanged(event: any) {
    this.formData.append('vehiclePic', event.target.files[0], event.target.files[0].name);
  }

  getGPSProviders() {
    console.log('>>')
    this.http.get('constants/carrier', '', 3).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {

          if (data.data.gps.length) {
            this.gps_providers = data.data.gps;
            if (this.gps_providers.length == 1) {
              this.selectGPSProvider(this.gps_providers[0]);
            }
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  submit() {
    if (!this.validate()) {
      return;
    }
    if (environment.country == 'IN' && !this.newVehicleData.gps_provider) {
      delete this.newVehicleData.gps_provider
    }

    this.http.post('v2/vehicle/add_one', this.newVehicleData).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.snackbar.openSnackBar(this.messages.VEHICLES.ADD_VEHICLE.SUCCESS.ADD);
          this.closeDialog(data);
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        this.formData = new FormData();
      }
    );

  }

  closeDialog(data = '') {
    this.dialog.close(data);
  }

  selectVehicle(type) {
    this.vehicleKey1._id = type._id;
    this.vehicleKey1.name = type.name;
    this.vehicleKey1.actual_capacity = type.capacity;
    this.newVehicleData.actual_capacity = type.capacity;
    this.removeFocus();
  }
  removeFocus() {
    const inputs: any = [].slice.call(document.getElementsByTagName('input'));
    inputs.forEach((element: HTMLElement) => {
      element.blur();
    });
  }
  getVehicleTypes() {
    this.http.get('carrier_pref').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {      
          if (data.data.vehicle_types.length) {
            this.vehicletypes = data.data.vehicle_types;
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  openVerifyModal(url) {
    window.open(url, '_blank');
  }

  // populate assets when provider is selected
  selectGPSProvider(provider) {
    if (environment.country == 'SA') {
      this.spinner = true;
      this.showGPSProvider = true;
      this.selectedGPSProvider = provider;
      this.newVehicleData.gps_provider = provider.value;
      this.selectedAsset = '';
      this.assets = [];
      this.assetsArray = [];
      this.http.get('ksa_gps/assets', { provider: provider.value }, 3).subscribe(
        (data: any) => {
          this.spinner = false;
          this.assetsArray = data.data;
          this.assets = data.data;
        },
        (err) => {
          this.spinner = false;
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        });
    } else {
      this.selectedGPSProvider = provider;
      this.newVehicleData.gps_provider = provider.value;
    }
  }

  selectAsset(asset) {
    this.selectedAsset = asset.reg_number;
    this.newVehicleData.gps_id = asset.asset_id;
  }

  applyFilter(value: string) {
    if (value) {
      this.assets = this.assets.filter(option => option.reg_number.includes(value));
    } else {
      this.newVehicleData.gps_id = '';
      this.assets = this.assetsArray;
    }
  }

  validate() {
    let valid = false;
    if (!this.newVehicleData.registrationNumber) {
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.VEHICLES.ADD_VEHICLE.VALIDATION.REGISTRATION_NUMBER_EMPTY'), '', 'err');
    } else if (environment.country == 'IN' && !this.validData.isVehicle(this.newVehicleData.registrationNumber)) {
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.VEHICLES.ADD_VEHICLE.VALIDATION.REGISTRATION_NUMBER'), '', 'err');
    } else if ((environment.country == 'SA' || environment.country == 'BR') && !this.validData.isKsaVehicle(this.newVehicleData.registrationNumber)) {
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.VEHICLES.ADD_VEHICLE.VALIDATION.REGISTRATION_NUMBER'), '', 'err');
    } else if (environment.country == 'SA' && this.newVehicleData.gps_provider && !this.newVehicleData.gps_id) {
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.VEHICLES.ADD_VEHICLE.VALIDATION.ASSETS'), '', 'err');
    } else if (!this.vehicleKey1._id) {
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.VEHICLES.ADD_VEHICLE.VALIDATION.VEHICLE_TYPE'), '', 'err');
    } else {
      valid = true;
      this.newVehicleData.type = this.vehicleKey1._id;
      const keys = Object.keys(this.newVehicleData);
      keys.forEach((key) => {
        if (!this.newVehicleData[key]) {
          delete this.newVehicleData[key];
        }
      });
    }
    return valid;
  }
}
